import { render, staticRenderFns } from "./AdminChannelsHome.vue?vue&type=template&id=3fe3f8dc&scoped=true&"
import script from "./AdminChannelsHome.ts?vue&type=script&lang=ts&"
export * from "./AdminChannelsHome.ts?vue&type=script&lang=ts&"
import style0 from "./AdminChannelsHome.vue?vue&type=style&index=0&id=3fe3f8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe3f8dc",
  null
  
)

export default component.exports